import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { UploadScriptData } from '@app/shared/components/dialogs/upload-script-dialog/upload-script-dialog.data';

@Component({
    selector : 'upload-script-dialog',
    template: require('./upload-script-dialog.component.html'),
    styles: [require('./upload-script-dialog.component.scss')]
})
export class UploadScriptDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: UploadScriptData) {
    }

    public processUploadScript(files) {
        for(let file of files) {
            this.data.files.push(file);
        }
    }
   public selectSchema(schema){
    this.data.schema = schema;
   }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/upload-script-dialog/upload-script-dialog.component.ts